var _templateObject = _taggedTemplateLiteralLoose(['\n  height: ', ';\n  width: ', ';\n  overflow: hidden;\n  position: fixed;\n  top: auto;\n  left: auto;\n  bottom: ', ';\n  right: ', ';\n  font-family: ', ';\n  z-index: 9999;\n\n  a {\n    color: ', ' !important;\n    font-weight: bold !important;\n    text-decoration: none;\n    transition: all 0.2s;\n  }\n\n  a:hover {\n    opacity: 0.6;\n    transition: all 0.2s;\n  }\n\n  ~ div {\n    width: 100%;\n  }\n\n  @media (min-width: 600px) {\n    height: ', ';\n    width: ', ';\n    overflow: visible;\n    position: absolute;\n    bottom: ', ';\n    right: ', ';\n  }\n'], ['\n  height: ', ';\n  width: ', ';\n  overflow: hidden;\n  position: fixed;\n  top: auto;\n  left: auto;\n  bottom: ', ';\n  right: ', ';\n  font-family: ', ';\n  z-index: 9999;\n\n  a {\n    color: ', ' !important;\n    font-weight: bold !important;\n    text-decoration: none;\n    transition: all 0.2s;\n  }\n\n  a:hover {\n    opacity: 0.6;\n    transition: all 0.2s;\n  }\n\n  ~ div {\n    width: 100%;\n  }\n\n  @media (min-width: 600px) {\n    height: ', ';\n    width: ', ';\n    overflow: visible;\n    position: absolute;\n    bottom: ', ';\n    right: ', ';\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { getNumber, getUnit } from '../utils';

var Container = styled.div(_templateObject, function (props) {
  return props.open ? '100%' : props.theme.buttonSize;
}, function (props) {
  return props.open ? '100%' : props.theme.buttonSize;
}, function (props) {
  return !props.open ? '' + getNumber(props.theme.padding) / 2 + getUnit(props.theme.padding) : 0;
}, function (props) {
  return !props.open ? '' + getNumber(props.theme.padding) / 2 + getUnit(props.theme.padding) : 0;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.color;
}, function (props) {
  if (!!props.open) {
    var padHeight = parseInt(props.theme.height, 10);
    var padInt = parseInt(props.theme.padding, 10);
    return padHeight + padInt + 32 + 'px';
  }
  return props.theme.buttonSize;
}, function (props) {
  return !!props.open ? props.theme.width : props.theme.buttonSize;
}, function (props) {
  return props.theme.padding;
}, function (props) {
  return props.theme.padding;
});

export default Container;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/components/container.js
// module id = 755
// module chunks = 1